import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { apiBaseUrl } from '../../shared/services/http-client/api-url.util';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';

/**
 * Envia o token do portal (`sToken`) como Bearer e a chave do gateway. Só nas
 * chamadas à própria API, para o token não vazar para outros hosts.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(apiBaseUrl())) {
    return next(req);
  }

  const headers: Record<string, string> = {};

  const token = inject(LocalStorageService).get('sToken');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const subscriptionKey = environment.ocpapimsubscriptionkey?.trim();
  if (subscriptionKey) {
    headers['Ocp-Apim-Subscription-Key'] = subscriptionKey;
  }

  return next(req.clone({ setHeaders: headers }));
};
